//
//  SDKWorkspaceNPMRegistryAuthType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Workspace registry auth type enum
// Following are possible:   Basic, Bearer
export var WorkspaceNPMRegistryAuthType;
(function (WorkspaceNPMRegistryAuthType) {
    /** The workspace is configured to be able to access registry with Basic auth */
    WorkspaceNPMRegistryAuthType["basic"] = "Basic";
    /** The workspace is configured to be able to access registry using Bearer token */
    WorkspaceNPMRegistryAuthType["bearer"] = "Bearer";
})(WorkspaceNPMRegistryAuthType || (WorkspaceNPMRegistryAuthType = {}));
